export const editsConstants = {
  EDITS_LIST_ADD: 'EDITS_LIST_ADD',
  EDITS_LIST_REMOVE: 'EDITS_LIST_REMOVE',
  EDITS_LIST_CLEAR: 'EDITS_LIST_CLEAR',
  EDITS_LIST_CHANGE: 'EDITS_LIST_CHANGE',
  EDITS_LIST_PAGINATION: 'EDITS_LIST_PAGINATION',
};
